module.exports = __webpack_public_path__ + "img/GraydeP.5fa4af37.jpg";